import { useTranslation } from 'react-i18next'
import Navbar from './Navbar'
import Footer from './Footer'
import CookieBanner from './CookieBanner'
import ScrollToTop from './ScrollToTop'
import QuickSidebar from './QuickSidebar'
import TranslationNotice from './TranslationNotice'

export default function Layout({ children }) {
    const { t } = useTranslation()
    return (
        <div className="flex flex-col min-h-screen">
            <ScrollToTop />
            <a
                href="#main"
                className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:start-4 focus:z-[10001] focus:rounded-lg focus:bg-navy focus:px-4 focus:py-2 focus:font-bold focus:text-mint"
            >
                {t('skipToContent')}
            </a>
            <Navbar />
            {/* tabIndex=-1 para o ScrollToTop poder mover-lhe o foco na mudança de rota */}
            <main id="main" tabIndex={-1} className="flex-grow pt-16 lg:pt-20 focus:outline-hidden">
                {/* O aviso de tradução automática só aparece nas línguas ≠ pt. */}
                <TranslationNotice />
                {children}
            </main>
            <Footer />
            <CookieBanner />
            <QuickSidebar />
        </div>
    )
}
